
import { TableConfig, DataTable } from "@app/interfaces";

export class SurveyDetailsTableConfig implements DataTable {

    constructor() { }

    static configure(): TableConfig {

        const tableConfig: TableConfig = {
            key: 'items',
            searchPanel: false,
            groupPanel: false,
            canEdit: false,
            canReorder: true,
            showPagination: {
                showPageSizeSelector: false,
                pageSize: 100,
                allowedPageSizes: [10, 20, 100]
            },
            fields: [
                {
                    caption: 'Name',
                    dataField: 'name'
                },
                {
                    caption: '',
                    width: 80,
                    cellTemplate: {
                        id: 'pusblish',
                        buttons: [{
                            name: "Publish",
                            eventName: "publish",
                            condition: (data: any) => !data.group && !data.published
                        }],
                    },
                },
                {
                    caption: '',
                    width: 100,
                    cellTemplate: {
                        id: 'itemsActionButtons',
                        buttons: [{
                            icon: 'fa-solid fa-pencil',
                            name: "Edit",
                            eventName: "edit",
                            cssClass: "me-2",
                            condition: (data: any) => !data.group
                        }, {
                            icon: 'fa-solid fa-trash',
                            name: "Delete",
                            eventName: "delete",
                            cssClass: "bg-danger",
                            condition: (data: any) => !data.group
                        }],
                    },
                },
            ]
        };

        return tableConfig;

    }

}